module.exports = __webpack_public_path__ + "static/media/01.0592ac21.png";